module.exports = __webpack_public_path__ + "img/1280x720-Festival.cae49f8e.jpg";